import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/coralteam.webp';
import screenshot_target from '../../../images/letterfunnel/alexmavrishchev.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Alex Mavrishchev"
      firstname="Alex"
      companyname="Coral Team"
      competition="Gen25 en Bright Cubes"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/alexmavrishchev.js